import { useCallback, useEffect, useState } from 'react';

export const LNA_STATES = {
    GRANTED: 'granted',
    DENIED: 'denied',
    PROMPT: 'prompt',
    UNSUPPORTED: 'unsupported',
    UNAVAILABLE: 'unavailable'
};

export function useLocalNetworkAccess() {
    const [LNAState, setLNAState] = useState(null);

    const requestLNA = useCallback(async () => {
        try {
            await fetch('http://192.168.1.1', {
                targetAddressSpace: 'local'
            });
        } catch (_) {}

        await checkLNA();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkLNA = useCallback(async () => {
        if (!navigator.permissions) {
            setLNAState(LNA_STATES.UNSUPPORTED);
            return;
        }

        try {
            const result = await navigator.permissions.query({
                name: 'local-network-access'
            });
            setLNAState(result.state); // prompt | granted | denied
        } catch {
            setLNAState(LNA_STATES.UNAVAILABLE);
        }
    }, []);

    useEffect(() => {
        checkLNA();
    }, [checkLNA]);

    return { LNAState, requestLNA };
}
